// Environment configuration with safe defaults
// This replaces hardcoded values with environment-aware constants
import { validateEnv } from './env-validation';

// Validate environment variables on import
const validatedEnv = validateEnv();

interface AppConfig {
  supabase: {
    url: string;
    anonKey: string;
    projectId: string;
  };
  app: {
    name: string;
    domain: string;
    supportEmail: string;
    shareUrlBase: string;
  };
  external: {
    calendarUrl: string;
    videoBaseUrl: string;
    webinarBaseUrl: string;
  };
  api: {
    saveProgressEndpoint: string;
  };
}

// Production-safe configuration
export const config: AppConfig = {
  supabase: {
    url: validatedEnv.VITE_SUPABASE_URL,
    anonKey: validatedEnv.VITE_SUPABASE_ANON_KEY,
    projectId: validatedEnv.VITE_SUPABASE_PROJECT_ID,
  },
  app: {
    name: "MySuccession",
    domain: typeof window !== 'undefined' ? window.location.origin : 'https://mysuccession.io',
    supportEmail: "support@mysuccession.io",
    shareUrlBase: typeof window !== 'undefined' ? `${window.location.origin}/s` : 'https://mysuccession.io/s'
  },
  external: {
    calendarUrl: "https://calendar.google.com/calendar/render",
    videoBaseUrl: "/videos",
    webinarBaseUrl: "/webinars"
  },
  api: {
    saveProgressEndpoint: "/api/save-progress"
  }
};

// Environment-specific overrides
if (typeof window !== 'undefined') {
  // Client-side environment detection
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    // Development overrides
  } else if (window.location.hostname.includes('staging') || window.location.hostname.includes('dev')) {
    // Staging overrides
  } else {
    // Production
  }
}

export default config;